import React, { MouseEventHandler } from 'react';
import './button.scss';

interface Props {
  id?: string;
  disabled?: boolean;
  type?: string;
  ref?: any;
  classStyle?: string;
  text: string;
  isSubmit?: boolean;
  image?: any;
  form?: string;
  onClick?: MouseEventHandler<HTMLInputElement> | any;
}

export const Button: React.FC<Props> = ({ classStyle, form, text, onClick, type, disabled, isSubmit }) => {
  return (
    <div>
      <input
        form={form}
        type={isSubmit ? 'submit' : 'button'}
        disabled={disabled}
        onClick={disabled ? () => '' : onClick}
        className={`button ${type} ${[classStyle].join(' ')} ${disabled ? 'disabled' : ''}`}
        value={text}
      />
    </div>
  );
};
